import { useLocation } from "react-router-dom";

export const useSegments = (_skipHiddenFolder = true): string[] => {
  const { pathname } = useLocation();
  const segments = pathname.split("/");

  return segments.filter(Boolean);
};
